import { DefaultState } from '@src/redux/types'

import {
  WORK_PLAN_ASSIGNED_ALL,
  WORK_PLAN_CREATE,
  WORK_PLAN_CREATED_ALL,
  WORK_PLAN_DELETE,
  WORK_PLAN_STAFF_LIST,
  WORK_PLAN_UPDATE,
  WORK_PLAN_UPDATE_STATUS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [WORK_PLAN_CREATED_ALL]: DefaultState<`${typeof API.WORK_PLAN_CREATED_ALL}`, 'get'>
  [WORK_PLAN_ASSIGNED_ALL]: DefaultState<`${typeof API.WORK_PLAN_ASSIGNED_ALL}`, 'get'>
  [WORK_PLAN_DELETE]: DefaultState<`${typeof API.WORK_PLAN}{id}`, 'delete'>
  [WORK_PLAN_CREATE]: DefaultState<`${typeof API.WORK_PLAN}`, 'post'>
  [WORK_PLAN_UPDATE]: DefaultState<`${typeof API.WORK_PLAN_UPDATE}`, 'post'>
  [WORK_PLAN_UPDATE_STATUS]: DefaultState<`${typeof API.WORK_PLAN_UPDATE_STATUS}`, 'post'>
  [WORK_PLAN_STAFF_LIST]: DefaultState<`${typeof API.WORK_PLAN_STAFF_LIST}`, 'get'>
} = () => ({
  [WORK_PLAN_CREATED_ALL]: defaultState(),
  [WORK_PLAN_ASSIGNED_ALL]: defaultState(),
  [WORK_PLAN_CREATE]: defaultState(),
  [WORK_PLAN_DELETE]: defaultState(),
  [WORK_PLAN_UPDATE]: defaultState(),
  [WORK_PLAN_UPDATE_STATUS]: defaultState(),
  [WORK_PLAN_STAFF_LIST]: defaultState(),
})
